export default "__VITE_ASSET__BkcwbdlZ__"